export default {
  DELETE_USER: 'deleteUser',
  GET_GROUP_LIST: 'getGroupList',
  GET_HEALTH_ALIVE: 'getHealthAlive',
  GET_USER_AUTH_REFRESH: 'getUserAuthRefresh',
  GET_USER_INFO: 'getUserInfo',
  GET_USER_LIST: 'getUserList',
  GET_USER_SUBSCRIBED_APPS: 'getUserSubscribedApps',
  POST_USER: 'postUser',
  POST_USER_AUTH_LOGIN: 'postUserAuthLogin',
  POST_USER_INVITE_RESEND: 'postUserInviteResend',
  PUT_USER: 'putUser',
  PUT_USER_ENABLED: 'putUserEnabled',
  SET_SESSION_USER: 'setSessionUser'
};
